/* 
 * SPINNER HELPER = JQuery Wrapper around spin.js that also allows for an optional
 * overlay type of spinner that adds a div to cover the whole window.
 * 
 * NOTE: Overlay
 */

// storing our standard options here so they can be accessed globally
var opts = { lines: 11, width: 3 };

define('core/ef_plugins/spinnerhelper',["jquery", "libs/spin"], function (jQuery, Spinner) {
    (function($, window, document, undefined) {

        var pluginName = 'spinnerhelper',
            defaults = {
                type: "inline", // or "overlay"
                delay: 500,
                spinOpts: { lines: 11, width: 3, scale: .5}
            };

        // The actual plugin constructor
        function SpinnerHelper(element, options) {
            // grab the element the plugin was called on
            this.element = element;

            // also save the element as a jquery object
            this.$element = $(element);

            // get per-element inline configuration settings
            this.metadata = this.$element.data('spinnerhelper-options');

            // merge all the configs
            this.options = $.extend({}, defaults, options, this.metadata);

            // make sure type is set to "inline" or "overlay"
            this.options.type = this.options.type.toLowerCase();
            if (this.options.type !== "inline" && this.options.type !== "overlay") return;

            // save the defaults
            this._defaults = defaults;

            // save the plugin name
            this._name = pluginName;

            // call init function
            this.init();
        }

        // Define this sucker
        SpinnerHelper.prototype = {
            init: function() {
                var plugin = this,
                    $body = $('body'),
                    $window = $(window);

                plugin.spinner = new Spinner(plugin.options.spinOpts);
                plugin.isSpinning = false;
                plugin.timeoutID = -1; // -1 means that no timeout has been created or the timeout has been cleared.

                if (plugin.options.type === "overlay") {
                    plugin.$overlay = $('<div class="spinner-overlay"></div>').css('display', 'none');
                    plugin.$centerer = $('<div class="spinner-centerer"></div>');
                    plugin.$element.append(plugin.$overlay.append(plugin.$centerer));
                }

                plugin.start();
            },

            // stop the spinner
            stop: function() {
                var plugin = this,
                    $body = $('body'),
                    $window = $(window);

                if (!plugin.isSpinning) {
                    // cancel the timeout
                    clearTimeout(plugin.timeoutID);
                    plugin.timeoutID = -1;
                    return;
                }

                // handle the two different types
                switch (plugin.options.type) {
                case "inline":
                    plugin.spinner.stop();
                    plugin.isSpinning = false;
                    break;
                case "overlay":
                    plugin.spinner.stop();
                    plugin.$overlay.css('display', 'none');
                    plugin.isSpinning = false;
                    break;
                }
            },

            // start the spinner
            start: function() {
                var plugin = this,
                    $body = $('body'),
                    $window = $(window);

                // if this is already spinning, exit the function
                if (plugin.isSpinning) return;

                switch (plugin.options.type) {
                case "inline":
                    plugin.timeoutID = _.delay(function() {
                        plugin.spinner.spin(plugin.element);
                        plugin.isSpinning = true;
                    }, plugin.options.delay);
                    break;
                case "overlay":
                    plugin.timeoutID = _.delay(function() {
                        plugin.$overlay.css('display', 'block');
                        plugin._centerSpinner();
                        plugin.spinner.spin(plugin.$centerer[0]);
                        plugin.isSpinning = true;
                    }, plugin.options.delay);
                    break;
                }
            },

            _centerSpinner: function() {
                var plugin = this,
                    elementoffset = plugin.$element.offset().top,
                    elementheight = plugin.$element.outerHeight(false),
                    elementbottom = elementoffset + elementheight,
                    docscrolltop = $(document).scrollTop(),
                    windowheight = $(window).height(),
                    docbottom = docscrolltop + windowheight,
                    isinwindow,
                    topoutofbounds,
                    inbounds,
                    cssheight,
                    csstop;

                // make sure that some portion of the element is inside the window
                isinwindow = elementoffset < docbottom && elementbottom > docscrolltop;

                // if the element isn't in view, just center the spinner in the whole element
                if (!isinwindow) {
                    cssheight = elementheight;
                    csstop = 0;
                } else {
                    // some part of the element is visible
                    // calculate what part of the top of the element is above the window
                    topoutofbounds = docscrolltop - elementoffset;

                    if (topoutofbounds >= 0) {
                        // *the top of the element is above the window or just at the top of the window*

                        // position the top of the centerer relative to its parent
                        csstop = topoutofbounds;

                        // calculate how much of the element is visible
                        inbounds = elementheight - topoutofbounds;

                        // if part of the element goes below the window, shorten the centerer to fit in the window
                        cssheight = inbounds > windowheight ? windowheight : inbounds;
                    } else {
                        // *negative number means the top of the element is inside the window, 
                        // and -topoutofbounds == the element's offset from the top of the window*

                        // position the top of the centerer at the top of the element
                        csstop = 0;

                        // calculate how much of the element is visible in the window
                        inbounds = windowheight + topoutofbounds; // topoutofbounds is negative so this actually subtracts

                        // if the entire element is visible in the screen
                        cssheight = inbounds > elementheight ? elementheight : inbounds;
                    }
                }

                // set the centerer css!
                plugin.$centerer.css({ 'width': plugin.$element.outerWidth(), 'height': cssheight, 'position': 'relative', 'top': csstop });

            },

            destroy: function() {
                var plugin = this;
                plugin.stop();

                if (plugin.options.type === "overlay") {
                    plugin.$overlay.remove();
                }

                plugin.$element.removeData('plugin_' + pluginName);
                return null;
            }

        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function(options) {
            return this.each(function() {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new SpinnerHelper(this, options)); // CHANGE: Plugin to plugin constructor defined above
                }
            });
        }

    })(jQuery, window, document);
});
